import { ICellRendererParams } from "ag-grid-community";
import { amphibiousGetIn, amphibiousSetIn } from "helpers/objUtils";
import * as React from "react";
import { connect } from "react-redux";
import { IStore } from "reducers";

interface IProps extends ICellRendererParams {
    statePaths?: string[][];
    transformValueToDisplay: (data: any, stateChunk: any) => string;
}

interface IStoreToProps {
    stateChunk: any;
}

class ReduxConnectedRenderer extends React.PureComponent<IProps & IStoreToProps> {
    constructor(props) {
        super(props);
    }

    render() {
        const { data, transformValueToDisplay, stateChunk } = this.props;
        const displayValue = transformValueToDisplay?.(data, stateChunk);
        return displayValue ? <React.Fragment>{displayValue}</React.Fragment> : null;
    }
}

const mapStateToProps = (state: IStore, ownProps: IProps) => {
    const { statePaths } = ownProps;
    if (statePaths) {
        return {
            stateChunk: statePaths.reduce((acc, path) => {
                amphibiousSetIn(acc, path, amphibiousGetIn(state, path));
                return acc;
            }, {}),
        };
    }
    return {};
};

export const GenericReduxConnectedRenderer = connect(mapStateToProps)(ReduxConnectedRenderer);
